export default (referer) => /^(?:https?:\/\/)?([a-z0-9-.]?)+\.nav\.(com|engineering)|navlocal.io|^\/(?!\/).*$/.test(referer);
//# sourceMappingURL=is-valid-referer.js.map